import { simpleSet } from '@r/reducers/utils';

const setCalculationModeCustomerAddress = simpleSet as
  redux.reducers.calculationMode.settings.information.customerAddress;

export const customerAddress = setCalculationModeCustomerAddress(
  'SET_CALCULATION_MODE_CUSTOMER_ADDRESS',
  ''
);
